import { RemoveCircle } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import { IGroupMessageView } from "../../App/Typings/MessageText";

export function ScheduledActionButtons({
  message,
  deleteSelectedScheduledMessages = () => {
    return;
  },
  disabled = false,
}: {
  deleteSelectedScheduledMessages: (msg: IGroupMessageView) => void;
  message: IGroupMessageView;
  disabled?: boolean;
}) {
  return (
    <Stack display="flex" justifyContent="center" direction="row">
      <IconButton
        data-test="cancel-delete-scheduled-message"
        color="error"
        title="Cancel/Delete this scheduled message."
        disabled={disabled}
        onClick={(event) => {
          event.stopPropagation();
          deleteSelectedScheduledMessages(message);
        }}
        sx={{
          border: "2px solid rgba(0,0,0,0.3)",
          transition: "all 0.2s ease-in-out",
          "&:hover": { backgroundColor: "error.main", color: "white" },
        }}
      >
        <RemoveCircle sx={{ fontSize: "1rem" }} />
      </IconButton>
    </Stack>
  );
}
